import { r, s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2TagGroupSx = {
  columnGap: s('md'),
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: `calc(24px * 2 + ${s('md')})`,
  minWidth: 0,
  overflow: 'hidden',
  rowGap: s('md'),
} satisfies SxProps<Theme>;

export const tableV2DenseTagGroupSx = {
  ...tableV2TagGroupSx,
  display: 'grid',
} satisfies SxProps<Theme>;

export const buildTableV2DenseTagColumns = (tagCount: number): string =>
  `repeat(${String(Math.ceil(tagCount / 2))}, minmax(0, 1fr))`;

export const tableV2TagChipSx = {
  borderRadius: r('sm'),
  flex: '0 1 auto',
  height: '24px',
  maxWidth: '100%',
  minWidth: 0,
  '& .MuiChip-label': {
    minWidth: 0,
    overflow: 'hidden',
    py: s('xxs'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
} satisfies SxProps<Theme>;

export const tableV2DenseTagChipSx = {
  width: '100%',
} satisfies SxProps<Theme>;
